export const STATUS_META = {
  scheduled: { label: "Scheduled", cls: "bg-slate-500/20 text-slate-400 border-slate-500/40", block: "rgba(100,116,139,0.75)" },
  committed: { label: "Committed", cls: "bg-green-600/20 text-green-300 border-green-600/40", block: "rgba(34,197,94,0.85)" },
  authorised: { label: "Authorised", cls: "bg-violet-600/20 text-violet-300 border-violet-600/40", block: "rgba(139,92,246,0.85)" },
  changed: { label: "Changed", cls: "bg-amber-600/20 text-amber-300 border-amber-600/40", block: "rgba(245,158,11,0.9)" },
  completed: { label: "Completed", cls: "bg-blue-600/20 text-blue-300 border-blue-600/40", block: "rgba(37,99,235,0.85)" },
  cancelled: { label: "Cancelled", cls: "bg-rose-400/15 text-rose-300 border-rose-400/40", block: "rgba(248,113,113,0.55)" },
};

export function taskStatus(t, pending, todayStr, nowMin) {
  if (t.status === "cancelled") return "cancelled";
  if (t.status === "completed") return "completed";  // explicit — set only via Post Task
  if (t.status === "authorised") return "authorised";
  if (pending && pending[t.id]) return "changed";
  const [eh, em] = (t.end || "0:0").split(":").map(Number);
  const endMin = (eh || 0) * 60 + (em || 0) + (t.debrief_min || 0);
  if (t.status === "committed") return "committed";
  if (t.date < todayStr) return "completed";  // legacy display for past tasks never post-tasked
  if (t.date === todayStr && endMin <= nowMin) return "completed";
  return "scheduled";
}
